import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReglaCorreoUsuarioViewModel } from './correosusuario.types';

@Injectable()
export class CorreosUsuarioService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getReglasByFilter(params: HttpParams): Observable<ReglaCorreoUsuarioViewModel[]> {
        return this.http.get<ReglaCorreoUsuarioViewModel[]>(this.baseUrl + 'api/comunes/correosusuario/byfilter/', { params: params }).pipe();
    }

    Save(list: ReglaCorreoUsuarioViewModel[]): Observable<any> {
        return this.http.post<ReglaCorreoUsuarioViewModel[]>(this.baseUrl + 'api/comunes/correosusuario', list).pipe();
    }
}
